<script setup lang="ts">
import { computed } from 'vue'
import { useTheme, type ThemeMode } from '../composables/useTheme'

// Циклический переключатель темы в шапке: клик идёт по кругу Системная → Светлая →
// Тёмная → Системная (см. useTheme). Иконка отражает ТЕКУЩИЙ режим, aria-label —
// режим + подсказку действия (доступность: клавиатурой Enter/Space, видимый фокус).
const { mode, cycle } = useTheme()

const LABEL: Record<ThemeMode, string> = {
  system: 'Системная',
  light: 'Светлая',
  dark: 'Тёмная',
}

const ariaLabel = computed(() => `Тема: ${LABEL[mode.value]}. Нажмите, чтобы сменить`)
</script>

<template>
  <button
    type="button"
    data-testid="theme-toggle"
    class="cursor-pointer rounded-md p-1.5 text-muted hover:text-text focus-visible:outline-2 focus-visible:outline-accent"
    :aria-label="ariaLabel"
    :title="ariaLabel"
    @click="cycle"
  >
    <!-- Системная: половина солнца/луны (авто) -->
    <svg v-if="mode === 'system'" data-testid="theme-icon-system" class="h-5 w-5" viewBox="0 0 24 24"
         fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
      <circle cx="12" cy="12" r="9" />
      <path d="M12 3v18" />
      <path d="M12 3a9 9 0 0 1 0 18z" fill="currentColor" stroke="none" />
    </svg>
    <!-- Светлая: солнце -->
    <svg v-else-if="mode === 'light'" data-testid="theme-icon-light" class="h-5 w-5" viewBox="0 0 24 24"
         fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
      <circle cx="12" cy="12" r="4" />
      <path d="M12 2v2M12 20v2M4.9 4.9l1.4 1.4M17.7 17.7l1.4 1.4M2 12h2M20 12h2M4.9 19.1l1.4-1.4M17.7 6.3l1.4-1.4" />
    </svg>
    <!-- Тёмная: луна -->
    <svg v-else data-testid="theme-icon-dark" class="h-5 w-5" viewBox="0 0 24 24"
         fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
      <path d="M21 12.8A9 9 0 1 1 11.2 3a7 7 0 0 0 9.8 9.8z" />
    </svg>
  </button>
</template>
